/** Routes du module — propriétaire : Agent A2a — Ventes (site public et catalogue). Contrat : exporter `routesPublic`. */
import type { RouteObject } from 'react-router';
import { Accueil, CataloguePublic, Contact, FicheProduitPublic } from './Pages';

export const routesPublic: RouteObject[] = [
  { index: true, element: <Accueil /> },
  { path: 'catalogue', element: <CataloguePublic /> },
  { path: 'produits/:slug', element: <FicheProduitPublic /> },
  { path: 'contact', element: <Contact /> },
];
